import React, { createContext, useContext, useReducer } from "react";
import reducer from "./reducer";

const PropertiesStateContext = createContext();
const PropertiesDispatchContext = createContext();

const PropertiesProvider = ({ children }) => {
  const initialState = {
    properties: [],
    isPropertiesLoading: false,
    property: {},
    isPropertyLoading: false,
    contact: {},
    isPostContactSubmitting: false,
    newsletterContact: {},
    isNewsletterContactSubmitting: false,
    review: null,
    isReviewSubmitting: false,
    reviews: null,
    isReviewsLoading: false,
    message: null,
    error: null,
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PropertiesStateContext.Provider value={state}>
      <PropertiesDispatchContext.Provider value={dispatch}>
        {children}
      </PropertiesDispatchContext.Provider>
    </PropertiesStateContext.Provider>
  );
};

const usePropertiesState = () => {
  const context = useContext(PropertiesStateContext);
  if (context === undefined) {
    throw new Error(
      `'usePropertiesState' must be used within a PropertiesProvider`
    );
  }
  return context;
};

const usePropertiesDispatch = () => {
  const context = useContext(PropertiesDispatchContext);
  if (context === undefined) {
    throw new Error(
      `'usePropertiesDispatch' must be used within a PropertiesProvider`
    );
  }
  return context;
};

const usePropertiesUnit = () => {
  return [usePropertiesState(), usePropertiesDispatch()];
};

export {
  usePropertiesDispatch,
  usePropertiesState,
  usePropertiesUnit,
  PropertiesProvider,
};